//todo: change to enum
import { convertOptionsToAutoComplete } from '../../../utils/convertOptionsToAutoCompleteOptions';

export type TravelFileStatusTypes =
    | 'Open'
    | 'Cancelled'
    | 'Close'
    | 'Quote'
    | 'Option'
    | 'In Process'
    | 'Proposal';
type TravelFileStatusTypesKeys =
    | 'OPEN'
    | 'CANCELLED'
    | 'CLOSE'
    | 'QUOTE'
    | 'OPTION'
    | 'IN_PROCESS'
    | 'PROPOSAL';

export const TravelFileStatusTypesEnum: { [key in TravelFileStatusTypesKeys]: TravelFileStatusTypes } = {
    OPEN: 'Open',
    CANCELLED: 'Cancelled',
    CLOSE: 'Close',
    QUOTE: 'Quote',
    OPTION: 'Option',
    IN_PROCESS: 'In Process',
    PROPOSAL: 'Proposal'
};
/**
 * The status every newly created CLIENT (individual) travel file starts in.
 *
 * A client file stays `In Process` until the customer pays: the first
 * non-cancelled Receipt / Transfer Receipt issued against it, or a confirmed
 * Pelecard charge, moves it to `Open` (markTravelFileOpenIfInProcess on the
 * server). Group travel files are not customer bookings and start `Open`.
 */
export const INITIAL_CLIENT_TRAVEL_FILE_STATUS: TravelFileStatusTypes = TravelFileStatusTypesEnum.IN_PROCESS;

export const TravelFileStatusTypesOptions: TravelFileStatusTypes[] = Object.values(TravelFileStatusTypesEnum);

export const TRAVEL_FILE_STATUS_TYPES_OPTIONS = convertOptionsToAutoComplete(TravelFileStatusTypesOptions);
